import { Ref, ReactNode, DetailedHTMLProps, HTMLAttributes, useImperativeHandle, useRef } from 'react';
import { Button } from 'react-aria-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleUp } from '@fortawesome/free-solid-svg-icons/faAngleUp';
import { PageToolbar, PageToolbarProps } from 'components/app-page/page-toolbar/PageToolbar';
import ErrorPage from 'components/base-elements/error/ErrorPage';
import LoadingPage from 'components/base-elements/loading/LoadingPage';



type AppPageProps = Readonly<DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>> & PageToolbarProps & {
	isError?: boolean;
	isLoading?: boolean;
	children?: ReactNode;
	showToolbar?: boolean;
	ref?: Ref<HTMLDivElement | null>;
}


export const AppPage = (props: AppPageProps) => {
	const { isError, isLoading, children, showToolbar = true, pageLabel, resetPageApi, csvData, className, ref, ...otherProps } = props;

	const innerRef = useRef<HTMLDivElement>(null);
	const appClassName = `component-app-page ${className ? ` ${className}` : ''}`;

	useImperativeHandle(ref, () => innerRef.current!, []);

	
	if (isError) return (
		<div className={appClassName} ref={innerRef}>
			{showToolbar &&
				<PageToolbar pageLabel={pageLabel} />}
			<ErrorPage />
		</div>
	);

	
	if (isLoading) return (
		<div className={appClassName} ref={innerRef}>
			{showToolbar &&
				<PageToolbar pageLabel={pageLabel} />}
			<LoadingPage />
		</div>
	);

	
	return (
		<div className={appClassName} ref={innerRef} {...otherProps}>
			
			<Button className='app-highlight-button btn app-page-scrollup' onPress={() => {
				if (innerRef && innerRef.current) {
					innerRef.current.scrollTo({ top: 0, behavior: 'smooth' });
				}
			}}>
				<FontAwesomeIcon icon={faAngleUp} />
			</Button>

			{showToolbar &&
				<PageToolbar
					pageLabel={pageLabel}
					resetPageApi={resetPageApi}
					csvData={csvData}
				/>}
			{children}
		</div>
	)
}